/**
 * 网站配置 操作封装
 */
import {BROWSER_STORE_NAME} from '@/config/setting';

/**
 * 获取缓存的 浏览器编码
 */
export function getBrowserCode() {
    let code = localStorage.getItem(BROWSER_STORE_NAME);
    if (!code) {
        code = sessionStorage.getItem(BROWSER_STORE_NAME);
    }
    return code;
}

/**
 * 缓存 浏览器编码
 * @param code 编码
 * @param remember 是否永久存储
 */
export function setBrowserCode(code, remember = false) {
    removeBrowserCode();
    if (code) {
        if (remember) {
            localStorage.setItem(BROWSER_STORE_NAME, code);
        } else {
            sessionStorage.setItem(BROWSER_STORE_NAME, code);
        }
    }
}

/**
 * 移除 浏览器编码
 */
export function removeBrowserCode() {
    localStorage.removeItem(BROWSER_STORE_NAME);
    sessionStorage.removeItem(BROWSER_STORE_NAME);
}